(() => {
  if (window.FlextailBFCartOffer) return;
  window.FlextailBFCartOffer = true;
  const timers = new WeakMap();

  const initialized = new WeakMap();
  const selector = '[data-ftbf-cart-offer]';
  const message = (text, values) => Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`__${key}__`, String(value)), text
  );

  function updateOffer(root) {
    const { currency, storeCurrency } = root.dataset;
    const exchange = window.Shopify?.currency;
    const rate = currency === storeCurrency ? 1 : Number(exchange?.rate);
    if (currency !== storeCurrency && exchange?.active !== currency) return;
    if (!Number.isFinite(rate) || rate <= 0) return;
    const signature = JSON.stringify([currency, rate, root.dataset.eligible, root.dataset.originalTotal, root.dataset.tiers]);
    if (initialized.get(root) === signature) return;

    let formatter, tiers;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency, currencyDisplay: 'code'
      });
      tiers = JSON.parse(root.dataset.tiers);
    } catch { return; }
    const quantum = 100 / (10 ** formatter.resolvedOptions().maximumFractionDigits);
    const money = amount => formatter.format(amount / 100);
    const eligible = Number(root.dataset.eligible);
    const total = Number(root.dataset.originalTotal);
    if (!Number.isFinite(eligible) || !Number.isFinite(total) || !tiers.length) return;
    tiers = tiers.map(tier => ({
      ...tier, minimum: Math.ceil(tier.minimum * rate / quantum - 1e-9) * quantum
    }));
    const selected = tiers.filter(tier => eligible >= tier.minimum).at(-1);
    const next = tiers.find(tier => eligible < tier.minimum);
    if (!selected) return;
    const setText = (selector, value) => {
      const element = root.querySelector(selector);
      if (element) element.textContent = value;
    };
    setText('[data-ftbf-available]', message(root.dataset.available, { RATE: selected.rate, CODE: selected.code }));
    const notice = root.querySelector('[data-ftbf-next]');
    if (notice) {
      notice.hidden = Boolean(next);
      notice.textContent = next ? '' : root.dataset.topTier;
    }
    root.querySelectorAll('[data-ftbf-step]').forEach((step, index) => {
      const tier = tiers[index];
      if (!tier) return;
      const reached = eligible >= tier.minimum;
      const isNext = tier === next;
      step.dataset.state = reached ? 'reached' : isNext ? 'next' : 'locked';
      step.toggleAttribute('data-current', tier === selected);
      if (tier === selected) step.setAttribute('aria-current', 'step');
      else step.removeAttribute('aria-current');
      step.querySelector('[data-ftbf-step-message]').textContent = reached
        ? (tier === selected ? root.dataset.stepCurrent : root.dataset.stepReached)
        : message(isNext ? root.dataset.stepNext : root.dataset.stepLocked, {
          AMOUNT: money(isNext ? tier.minimum - eligible : tier.minimum)
        });
      const track = step.querySelector('[role="progressbar"]');
      const progress = tier.minimum ? Math.min(100, eligible * 100 / tier.minimum) : 100;
      track.hidden = !isNext;
      track.setAttribute('aria-valuenow', String(Math.round(progress * 100) / 100));
      track.firstElementChild.style.width = `${progress}%`;
    });
    setText('[data-ftbf-code-title]', `${selected.code} · ${message(root.dataset.extraOff, { RATE: selected.rate })}`);
    const copy = root.querySelector('.ftbf-cart__code [data-ftbf-cart-copy]');
    if (copy) {
      copy.dataset.ftbfCartCopy = selected.code;
      copy.setAttribute('aria-label', message(root.dataset.copyLabel, { CODE: selected.code }));
      const label = message(root.dataset.copyAction, { CODE: selected.code });
      copy.dataset.originalLabel = label;
      copy.querySelector('[data-ftbf-copy-label]').textContent = label;
      clearTimeout(timers.get(copy));
      timers.delete(copy);
    }
    setText('[data-ftbf-estimate-label]', message(root.dataset.estimatedWith, { CODE: selected.code }));
    const saving = Math.round(eligible * selected.rate / 100 / quantum) * quantum;
    setText('[data-ftbf-estimate]', money(total - saving));
    root.querySelectorAll('[data-ftbf-tier-minimum]').forEach(choice => {
      const minimum = Number(choice.dataset.ftbfTierMinimum);
      if (minimum > 0) {
        const converted = Math.ceil(minimum * rate / quantum - 1e-9) * quantum;
        choice.querySelector('[data-ftbf-choice-minimum]').textContent = message(root.dataset.ordersOver, { AMOUNT: money(converted) });
      }
    });
    initialized.set(root, signature);
  }

  function initialize(container) {
    if (container.matches?.(selector)) updateOffer(container);
    container.querySelectorAll(selector).forEach(updateOffer);
  }
  initialize(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes' && record.target.matches(selector)) updateOffer(record.target);
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) initialize(node);
      }
    }
  }).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-eligible', 'data-original-total', 'data-tiers', 'data-currency']
  });
  window.addEventListener('load', () => initialize(document));
  window.addEventListener('pageshow', () => initialize(document));

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ftbf-cart-copy]');
    if (!button) return;
    const root = button.closest('[data-ftbf-cart-offer]');
    const code = button.dataset.ftbfCartCopy;
    if (!root || !code) return;

    let success = false;
    try {
      await navigator.clipboard.writeText(code);
      success = true;
    } catch {
      const input = document.createElement('textarea');
      const previousFocus = document.activeElement;
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px';
      root.append(input);
      input.focus({ preventScroll: true });
      input.select();
      try { success = document.execCommand('copy'); } catch {}
      input.remove();
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    }
    if (!button.isConnected) return;
    const label = button.querySelector('[data-ftbf-copy-label]');
    const status = root.querySelector('[data-ftbf-cart-status]');
    if (!button.dataset.originalLabel) button.dataset.originalLabel = label.textContent;
    clearTimeout(timers.get(button));
    status.classList.toggle('ftbf-cart__status--manual', !success);
    if (success) {
      label.textContent = root.dataset.copied;
      status.textContent = root.dataset.success.replace('__CODE__', code);
      timers.set(button, setTimeout(() => {
        label.textContent = button.dataset.originalLabel;
        timers.delete(button);
      }, 1800));
    } else {
      label.textContent = button.dataset.originalLabel;
      status.textContent = `${root.dataset.manual} ${code}`;
    }
  });
})();
